<template>
  <div>
    <nav class="navbar navbar-default menu-nav menu_two" id="main_navbar">
    <div class="container">
      <div class="navbar-header">

        <router-link to="/registro-de-pontos" class="navbar-brand">
          <img src="../../../assets/img/logo-blue-new.png" alt="logo" class="img-responsive new-logo">
        </router-link>

        <a v-on:click="confirmLogoutPoint" class="dropdown certa logout-xs" >
          Sair<i class="fa fa-sign-out exit" aria-hidden="true"></i>
        </a>
      </div>

      <div class="navbar-collapse collapse" id="navbar">
        <ul class="nav navbar-nav navbar-right menu-left menu">
          <li>
            <span class="company-name">Empresa: {{companyName}}</span>
          </li>
          <li v-on:click="confirmLogoutPoint" class="dropdown" >
            <a>Sair</a>
            <i class="fa fa-sign-out exit" aria-hidden="true"></i>
          </li>
        </ul>
      </div>
    </div>
    </nav>
  </div>
</template>

<script>
  import { EXIT_MODE_POINT, USER_ACCESS } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";

  import swal from 'sweetalert';

  export default {
    name: 'navbar',
    data() {
      return {
        companyName: "",
        pathName: '',
        browserId: '',
      }
    },
    methods: {
      logoutPoint() {
        REQUEST_SERVICE.logout().then((response) => {
          swal.stopLoading();
          swal.close();

          window.localStorage.removeItem('modePin');

          this.$router.push({path: '/login'});
        }).catch(reason => {
          swal("Aviso", "Falha ao realizar logout", "error");
        });
      },
      confirmLogoutPoint() {
        swal({
          text: 'Informe a senha para sair.',
          content: "input",
          inputType: "password",
          button: {
            text: "Confirmar",
            closeModal: false,
          },
        }).then(pass => {
          if (!pass) throw null;

          REQUEST_SERVICE.post(EXIT_MODE_POINT, {newPassword: pass}).then((response) => {
            UTIL_SERVICE.console("RESULT EXIT_MODE_POINT:", response.data);

            this.logoutPoint();
          }).catch(reason => {
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        }).catch(err => {
          swal.stopLoading();
          swal.close();
        });

        $(".swal-content").find("input").attr("type", "password");
      },
      sendIdentifier() {
        setTimeout(function () {
          let browserInfo = UTIL_SERVICE.checkBrowser();

          // i = id do usuario logado
          const { dark } = JSON.parse(window.localStorage.getItem('darkMode'))

          if ($('#identifier').attr('class')) {
            let url = USER_ACCESS;
            url += "?deviceModel=" + browserInfo.name;
            url += "&i=" + JSON.parse(window.localStorage.getItem('userInfo')).id;
            url += "&version=" + browserInfo.version;
            url += "&deviceId=" + this.browserId;
            url += "&pushToken=" + $('#identifier').attr('class');

            if(dark === true) {
              url += "&themeMode=" + "2" 
            } else {
              url += "&themeMode=" + "1"
            }

            UTIL_SERVICE.console("URL Send:", url);
            REQUEST_SERVICE.get(url).then((response) => {
              UTIL_SERVICE.console("RESULT USER_ACCESS:", response);

              window.localStorage.setItem('userAccess', JSON.stringify(response.data));
            }).catch(reason => {

            });
          }
        }, 2000);
      },
    },
    beforeMount() {
      this.companyName = JSON.parse(window.localStorage.getItem('userInfo')).company.name;

      let mode = JSON.parse(window.localStorage.getItem('modePin'));
      if (mode) {
        if (mode.onlyPin === true) {
          if (this.pathName !== "/registro-de-pontos") {
            this.$router.push({path: '/registro-de-pontos'});
          }
        }
      }

      // Set BrowserID
      this.browserId = JSON.parse(window.localStorage.getItem('browserId'));

      if (this.browserId === null) {
        this.browserId = UTIL_SERVICE.randomToken();
        window.localStorage.setItem('browserId', JSON.stringify(this.browserId));
      }
    },
    created() {
      if (!sessionStorage.identifier) {
        sessionStorage.identifier = true;
        this.sendIdentifier();
      }

    },
  }
</script>

<style lang="scss">
  $nav-color: #0F77AE;
  $nav-collapse: #FFFFFF;
  $nav-collapse-text: #0F77AE;
  $text-nav-color: #FFFFFF;
  $text-nav-color-hover: #FFFFFF;
  $text-nav-color-active: #2A2A2A;

  .logout-xs {
    display: none;

    @media screen and (max-width: 420px) {
      display: block;
      float: right;
      cursor: pointer;
      margin-right: 15px;
      font-size: 26px;
      margin-top: 0;
      position: relative;
      top: -26px;
      color: #1a0f6b;

      i {
        font-size: 22px;
      }
    }
  }

  .swal-modal {
    .swal-content {

      input {
        -webkit-border-radius: 25px !important;
        -moz-border-radius: 25px !important;
        border-radius: 25px !important;
      }
    }

    .swal-button--confirm {
      background: #0f77ae;

      &:hover {
        background: #175D94;
      }
    }
  }

  .menu-left {
    position: relative;
    top: 32px;

    @media screen and (max-width: 780px){
      top: -54px;
    }
  }

  .new-logo {
    width: 100%;
    margin-top: 10px;
    display: inline-block !important;

    @media screen and (max-width: 780px){
      width: 30%;
      margin-top: 10px;
    }

    @media screen and (max-width: 420px){
      width: 55%;
    }
  }

  .exit {
    cursor: pointer;
    color: #3A424E;
    font-size: 16px;
    margin-left: 10px;
  }

  .navbar {
    z-index: 900;
    background: #ffffff;
    margin: 0;
    height: 90px;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.075);
    border-radius: 0;
    -webkit-box-shadow: inset 0 1px 0 rgba(255,255,255,.15), 0 1px 5px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 0 rgba(255,255,255,.15), 0 1px 5px rgba(0,0,0,.075);

    .company-name {
      color: #3A424E;
      font-size: 18px;
      font-weight: 500;
    }

    .navbar-collapse {
      .nav {
        padding-bottom: 20px;
    }

      @media only screen and (max-device-width: 420px) {
        background: $nav-collapse-text;
        margin-top: 37px;

        ul {
          li {
            margin-top: 25px;
            a {
              font-size: 14px;
              color: $nav-collapse;
              font-weight: bold;
              box-shadow: unset;
              background-color: transparent;
            }
          }
        }
      }
    }

    .navbar-header {

      .navbar-toggle {

        .icon-bar {
          height: 3px;
          background: #fff;
        }

        &:hover,&:active,&:focus{
          background: transparent;
        }

        @media only screen and (max-device-width: 768px) {
          top: 15px;
          right: 15px;
        }
      }
    }

    .navbar-nav {

      li {
        margin-left: 15px;

        a {
          color: #3A424E;
          font-size: 18px;
          font-weight: 400;
          display: inline-block;
          padding: 0;
          margin-top: 2px;
          margin-left: 40px;

          &:hover{
            color: #3A424E;
            text-decoration: underline;
            cursor: pointer;
          }

          @media only screen and (max-device-width: 768px) {
            font-size: 14px;
            margin-top: 0;
          }
        }

        img {
          width: 40px;
          display: inline-block;

          @media only screen and (max-device-width: 768px) {
            width: 40px;
            height: 40px;
          }
        }

        @media only screen and (max-device-width: 768px) {
            margin-top: 35px;
        }
      }

      .active {
        a {
          color: $text-nav-color-active;
          background-color: transparent;
          box-shadow: unset;
        }
      }

      .open {
        a {
          background-color: transparent;
          box-shadow: unset;

          span {
            color: $text-nav-color;
          }

          &:hover {
            background-color: transparent;
            box-shadow: unset;
          }

          @media only screen and (max-device-width: 414px) {
            color: #FFFFFF !important;
          }
        }
      }
    }

    .dropdown-menu {
      li {
        margin: 5px 15px;
        a {
          font-size: 15px;
          color: #898383;
          padding: 12px 0;
          width: 100%;
          height: 100%;

          &:hover {
            color: #111;
          }

          @media only screen and (max-device-width: 414px) {
            color: #FFFFFF !important;
          }
        }
      }
    }

    .dropdown-header {
      padding-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/components/navbar.vue